import { render, staticRenderFns } from "./RelatorioTaxaOscilacaoRiscosRetrato.vue?vue&type=template&id=7c2b449e"
import script from "./RelatorioTaxaOscilacaoRiscosRetrato.vue?vue&type=script&lang=js"
export * from "./RelatorioTaxaOscilacaoRiscosRetrato.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTaxaOscilacaoRiscosRetrato.vue?vue&type=style&index=0&id=7c2b449e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports